import { NgModule } from '@angular/core';

import { SSRService } from './ssr.service';

@NgModule({
    imports: [],
    providers: [
        SSRService,
    ],
})
export class SSRModule {}